// extracted by mini-css-extract-plugin
export default {"table_filters":"filters_table_filters__39UFw","table_filters_item":"filters_table_filters_item__9zwA3"};